import React from 'react';
import PropTypes from 'prop-types';

import Image from 'common/Image';
import logo from 'images/logo.svg';

import { withIntlProvider } from 'modules/utils';
import FormFooter from './FormFooter';
import { SideBarContainer, SideBarLogoWrapper } from '../styles';

import { locales } from '../locales';

const SideBar = ({ children }) => {
	return (
		<SideBarContainer>
			<SideBarLogoWrapper>
				<Image
					dimensions={{ height: '2.3rem', margin: '20px auto 0' }}
					source={logo}
					altText="Lavu"
				/>
			</SideBarLogoWrapper>
			{children}
			<FormFooter />
		</SideBarContainer>
	);
};

SideBar.propTypes = {
	children: PropTypes.node.isRequired,
};

export default withIntlProvider(locales)(SideBar);
